import React from "react";

export const CheckIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <g clipPath="url(#clip0_1872_6860)">
        <path
          d="M16 2.66699C8.63996 2.66699 2.66663 8.64033 2.66663 16.0003C2.66663 23.3603 8.63996 29.3337 16 29.3337C23.36 29.3337 29.3333 23.3603 29.3333 16.0003C29.3333 8.64033 23.36 2.66699 16 2.66699ZM13.3333 22.667L6.66663 16.0003L8.54663 14.1203L13.3333 18.8937L23.4533 8.77366L25.3333 10.667L13.3333 22.667Z"
          fill="var(--inzeloop-ds-color-feedback-success-border)"
        />
      </g>
      <defs>
        <clipPath id="clip0_1872_6860">
          <rect
            width="32"
            height="32"
            fill="var(--inzeloop-ds-color-icon-inverse)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
